import React from "react";
import { Typography } from "antd";
import DistributionChart from "./DistributionChart";

const { Title } = Typography;

const StudentCurriculums = ({ streams = [], report_period }) => {
  if (!streams.length) return null;

  return (
    <div
      style={{
        width: "210mm",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        boxSizing: "border-box",
      }}
    >
      {streams.map((stream) =>
        stream.learning_activities?.map((activity) =>
          activity.curriculums?.map((item, index) => {
            const {
              curriculum = {},
              runtime_competency_rate = 0,
              homework_rate = 0,
              parent_engagement_rate = 0,
              pending_homework = 0,
              submitted_homework = 0,
              verified_homework = 0,
              total_homework = 0,
              profile_risk = "",
              progress_status = "",
              status = "",
              runtime_grade = "",
              grade_distribution = {},
              overall_summary = {},
            } = item;

            const normalizedGrade =
              runtime_grade === "E" || runtime_grade === "U"
                ? "D"
                : runtime_grade;

            return (
              <div
                key={item._id || index}
                className="pdf-page curriculum-block"
                style={{
                  width: "210mm",
                  minHeight: "297mm",
                  padding: "8mm",
                  margin: "0 auto 15px auto",
                  background: "#fff",
                  border: "1px solid #ccc",
                  boxSizing: "border-box",
                  display: "block",
                  pageBreakAfter: "always",
                  pageBreakBefore: "always",
                  pageBreakInside: "avoid",
                  breakInside: "avoid-page",
                  overflow: "visible",

                }}
              >
                <div style={{
                  display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  padding: "8px",
                  background: "#f9f9f9",
                }}>
                  <Title level={3} style={{ color: "#50B6F2", margin: 0 }}>
                    {activity.name}
                  </Title>


                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      breakInside: "auto",
                      pageBreakInside: "auto",
                      overflow: "visible",
                    }}
                  >
                    <Title level={4} style={{ color: "#50B6F2", margin: "0 0 6px 0" }}>
                      {curriculum?.name || "Curriculum"}{" "}
                      {curriculum?.nominal_year_level ? `(Level ${curriculum.nominal_year_level})` : ""}
                    </Title>

                    <div
                      style={{
                        background: "#f2f2f2",
                        padding: "10px",
                        fontSize: "12px",
                        breakInside: "avoid",
                        pageBreakInside: "avoid",
                      }}
                    >
                      <b style={{ color: "#50B6F2" }}>Subject Outline</b>
                      <p style={{ textAlign: "justify" }}>
                        In <b>{report_period}</b>, students improved various skills related to <b>{curriculum?.name}</b> through engaging lessons and assessments.
                      </p>
                    </div>

                    <div style={{ display: "flex", gap: "20px", breakInside: "avoid", pageBreakInside: "avoid" }}>
                      <div style={{ flex: 1, padding: "4px" }}>
                        <h4 style={{ marginBottom: "5px", fontWeight: "bold" }}>GRADE</h4>
                        <Title level={1} style={{ color: "#50B6F2", margin: 0 }}>
                          {normalizedGrade || "-"}
                        </Title>
                      </div>
                      <div style={{ flex: 2, padding: "4px" }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>DISTRIBUTION</h4>
                        <DistributionChart chartData={grade_distribution} studentGrade={normalizedGrade} />
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", breakInside: "avoid", pageBreakInside: "avoid" }}>
                      <div style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>Academic Performance</h4>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                          <tbody>
                            <tr><td>1. Competency Rate</td><td>{runtime_competency_rate.toFixed(2)}%</td></tr>
                            <tr><td>2. Homework Rate</td><td>{homework_rate}%</td></tr>
                            <tr><td>3. Parent Engagement Rate</td><td>{parent_engagement_rate}%</td></tr>
                            <tr><td>4. Profile Risk</td><td style={{ color: profile_risk === "high" ? "#FF1A1A" : profile_risk === "medium" ? "#F3CC00" : "#00CE08", fontWeight: "bold" }}>{profile_risk && profile_risk.charAt(0).toUpperCase() + profile_risk.slice(1).toLowerCase()}</td></tr>
                            <tr><td>5. Progress Status</td><td>{progress_status}</td></tr>
                            <tr><td>6. Curriculum Status</td><td>{status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : "-"}</td></tr>
                          </tbody>
                        </table>
                      </div>

                      <div style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>Homework Progress</h4>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                          <tbody>
                            <tr><td>1. Submitted Homework</td><td>{submitted_homework}</td></tr>
                            <tr><td>2. Verified Homework</td><td>{verified_homework}</td></tr>
                            <tr><td>3. Pending Homework</td><td>{pending_homework}</td></tr>
                            <tr><td>4. Total Homework</td><td>{total_homework}</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {overall_summary && Object.keys(overall_summary).length > 0 && (
                      <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "8px", padding: "10px", background: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.05)", breakInside: "auto", pageBreakInside: "auto" }}>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <h4 style={{ marginBottom: "3px", color: "#50B6F2" }}>Observations:</h4>
                          <p style={{ marginBottom: "0" }}>We are showing only the mistakes that were marked</p>
                        </div>
                        {(() => {
                          const globalMax = Math.max(...Object.values(overall_summary).flatMap(subs => Object.values(subs)));
                          return Object.entries(overall_summary).map(([category, subs], idx) => (
                            <div key={idx} style={{ marginBottom: "4px", padding: "4px", border: "1px solid #eee", borderRadius: "6px", background: "#fafafa" }}>
                              <p style={{ fontWeight: "600", marginBottom: "3px", fontSize: "14px", color: "#333" }}>{category}</p>
                              {Object.entries(subs).map(([subName, count]) => {
                                const barWidth = globalMax ? (count / globalMax) * 100 : 0;
                                return (
                                  <div key={subName} style={{ display: "flex", alignItems: "center", fontSize: "12px", marginBottom: "3px" }}>
                                    <div style={{ width: "130px" }}>{subName}</div>
                                    <div style={{ width: "1px", background: "#ccc", height: "12px", margin: "0 6px" }} />
                                    <div style={{ flex: 1, height: "12px", position: "relative" }}>
                                      <div style={{ width: `${barWidth}%`, background: "#50B6F2", height: "100%", borderRadius: "2px" }} />
                                    </div>
                                    <div style={{ minWidth: "28px", textAlign: "right", fontWeight: "bold" }}>{count}</div>
                                  </div>
                                );
                              })}
                            </div>
                          ));
                        })()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )
      )}
    </div>
  );
};

export default StudentCurriculums;